import React from "react";

const STYLES = {
  "Not Started": "bg-ink-700 text-zinc-300 border-ink-600",
  "In Edit": "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "In Review": "bg-brand/10 text-brand border-brand/40",
  "Launched": "bg-violet-500/10 text-violet-300 border-violet-500/30",
  "Assigned": "bg-ink-700 text-zinc-300 border-ink-600",
  "In Progress": "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "Submitted": "bg-blue-500/10 text-blue-300 border-blue-500/30",
  "Ready for Review": "bg-brand/10 text-brand border-brand/40",
  "Sent to Client": "bg-violet-500/10 text-violet-300 border-violet-500/30",
  "Approved": "bg-brand text-ink-900 border-brand",
  "Needs Changes": "bg-red-500/10 text-red-400 border-red-500/40",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
    className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border whitespace-nowrap ${STYLES[status] || "bg-ink-700 text-zinc-300 border-ink-600"}`}
  >
    {status}
  </span>
);

export const RoleBadge = ({ role }) => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide bg-ink-700 text-brand border border-ink-600">
    {role}
  </span>
);
